// extracted by mini-css-extract-plugin
export var rightPanelOpenOld = "_9z-0";